import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthPage from "@/pages/AuthPage";
import ChaptersPage from "@/pages/ChaptersPage";
import GamePage from "@/pages/GamePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="screen-center pixel-text text-2xl text-[#9CA3AF]" data-testid="auth-loading">Loading...</div>;
  return user ? children : <Navigate to="/login" replace />;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return null;
  return user ? <Navigate to="/" replace /> : children;
};

function App() {
  return (
    <div className="App">
      <div className="grain" aria-hidden />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
            <Route path="/" element={<Protected><ChaptersPage /></Protected>} />
            <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
            <Route path="/play/:chapterId" element={<Protected><GamePage /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#12141C", color: "#F3F4F6", border: "2px solid #2E3440", borderRadius: 0, fontFamily: "VT323, monospace", fontSize: "1.15rem", boxShadow: "4px 4px 0 #000" } }} />
    </div>
  );
}

export default App;
